import MoreVert from '@mui/icons-material/MoreVert'
import IconButton from '@mui/material/IconButton'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import React, { useCallback } from 'react'

import VacationHoldChip from 'components/common/chip/VacationHoldChip'

import type { VacationHoldApi } from 'types/api/account/vacationHold'

type Props = {
  hold: VacationHoldApi
  primary?: string | null
  secondary?: string
  divider?: boolean
  onOpenActionMenu: (event: React.MouseEvent<HTMLElement>, hold: VacationHoldApi) => void
}

const TEXT_SLOT_PROPS = {
  primary: { variant: 'h6', fontWeight: 'normal', noWrap: true },
  secondary: { variant: 'body1', noWrap: true },
} as const

const HoldListItem: React.FC<Props> = ({ primary, hold, secondary, divider = false, onOpenActionMenu }) => {
  const handleOpenActionMenu = useCallback(
    (event: React.MouseEvent<HTMLElement>) => onOpenActionMenu(event, hold),
    [hold, onOpenActionMenu]
  )

  return (
    <ListItem
      divider={divider}
      secondaryAction={
        <IconButton onClick={handleOpenActionMenu}>
          <MoreVert />
        </IconButton>
      }
    >
      <ListItemIcon sx={{ mr: 1 }}>
        <VacationHoldChip label={hold.type} type={hold.type} />
      </ListItemIcon>
      <ListItemText primary={primary} secondary={secondary} slotProps={TEXT_SLOT_PROPS} />
    </ListItem>
  )
}

export default HoldListItem
